import './Logo.scss'
import React from 'react'
import logoSvg from '../assets/logo.svg'

const Logo = () => {
  return (
    <div className='Logo'>
      <img src={logoSvg} alt='Logo' />
    </div>
  )
}

Logo.displayName = 'Logo'

export default Logo



// WEBPACK FOOTER //
// ./src/lib/Logo.js